import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomMaterialModule } from '../custom-material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MenuListItemComponent } from './menu-list-item/menu-list-item.component';
import { RouterModule } from '@angular/router';
import { SideNavbarComponent } from './side-navbar/side-navbar.component';
import { AppUsersComponent, CreateAppUsersDialog } from './app-users/app-users.component';

@NgModule({
  declarations: [
    MenuListItemComponent,
    SideNavbarComponent,
    AppUsersComponent, CreateAppUsersDialog
  ],
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    CustomMaterialModule,
    ReactiveFormsModule, FormsModule
  ],
  exports: [
    MenuListItemComponent,
    SideNavbarComponent,
    AppUsersComponent
  ],
  providers: [
    
  ],
  entryComponents: [ CreateAppUsersDialog ]
})
export class ShareModule { }
